import { useToggleState } from '@shared/hooks';

export const useFileItem = () => {
    const [isHovered, toggleHover, setToggle] = useToggleState(false);

    const onFileItemClick = () => {
        setToggle(false);
    };
    const onFileItemMouseEnter = () => {
        setToggle(false);
        toggleHover();
    };

    return {
        isHovered,
        toggleHover,
        onFileItemMouseEnter,
        onFileItemClick,
    };
};
